import { UliActivityType } from '../../../../../../common';

export class UliBriefLoad {
  public static readonly type = '[UliBrief] Load';

  constructor(
    public payload: {
      compartmentId: number;
      type: UliActivityType;
      uli: string;
    },
  ) {}
}

export class UliBriefInitialState {
  public static readonly type = '[UliBrief] Set Initial State';
}
